import React, { useMemo } from 'react'
import { Stack } from '@mantine/core'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import PageEmpty from '../../../components/PageEmpty'
import BbgdexRiskBlackInfoOverview from './BbgdexRiskBlackInfoOverview'
import RiskScoreTable from './sections/RiskScoreTable'
import LoanInstitutionTable from './sections/LoanInstitutionTable'
import RecentApplicationTable from './sections/RecentApplicationTable'
import OverdueTable from './sections/OverdueTable'
import RepaymentTable from './sections/RepaymentTable'
import { InfoProps } from './types'

const parseData = (raw: any) => {
  if (!raw?.bbgdex_risk_black_info) return null
  try {
    if (typeof raw.bbgdex_risk_black_info === 'object') {
      return raw.bbgdex_risk_black_info
    }
    return JSON.parse(raw.bbgdex_risk_black_info)
  } catch (error) {
    console.error('Failed to parse bbgdex_risk_black_info:', error)
    return null
  }
}

export default function BbgdexRiskBlackInfo({ data, title, sectionIndex }: InfoProps) {
  const parsedData = useMemo(() => parseData(data), [data])

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      {!parsedData ? (
        <PageEmpty />
      ) : (
        <Stack gap="md" className="mt-2">
          <BbgdexRiskBlackInfoOverview data={parsedData} />
          <RiskScoreTable data={parsedData} />
          <LoanInstitutionTable data={parsedData} />
          <RecentApplicationTable data={parsedData} />
          <OverdueTable data={parsedData} />
          <RepaymentTable data={parsedData} />
        </Stack>
      )}
    </ReportWrapper>
  )
}
